import { NotificationsNone } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
type BellProps = {
  notes: string
  submitClick: () => void
}
export const Bell = ({ notes, submitClick }: BellProps) => {
  if (!notes) {
    return <></>
    // return (
    //   <Box
    //     onClick={submitClick}
    //     className="rounded-full cursor-pointer bg-gray-100 w-[20px] h-[20px] flex justify-center items-center border-solid border border-gray-600">
    //     <Edit className="text-gray-700 w-[15px] h-[15px]" />
    //   </Box>
    // )
  }
  return (
    <Tooltip
      title={<p className="whitespace-pre-line">{notes}</p>}
      style={{ whiteSpace: 'pre-line' }}
      placement="top"
      onClick={submitClick}
    >
      {/* <Box className="rounded-full cursor-pointer bg-gray-100 w-[20px] h-[20px] flex justify-center items-center border-solid border border-gray-600"> */}
      <NotificationsNone className="text-gray-700 w-[20px] h-[20px]" />
      {/* </Box> */}
    </Tooltip>
  )
}
